import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "hide" ];

  connect() {
    this.element.addEventListener("focusin", this.rememberFocusOrigin)
  }

  disconnect() {
    this.element.removeEventListener("focusin", this.rememberFocusOrigin)
  }

  hide() {
    if (this.hasHideTarget) {
      this.hideTarget.style.display = "none";
    } else {
      this.element.style.display = "none";
    }
    this.restoreFocus()
  }

  rememberFocusOrigin = (event) => {
    if (event.relatedTarget && !this.element.contains(event.relatedTarget)) {
      this.focusOrigin = event.relatedTarget
    }
  }

  restoreFocus() {
    if (this.focusOrigin?.isConnected) this.focusOrigin.focus()
  }
}
